import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { useEffect, useState } from 'react';
import { Button, Skeleton } from 'antd';
import { ReferenceCard } from './class-dashboard.styles';
import { ClassAssignmentItem } from './class-assignment-item.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Reference = function Reference(_ref) {
  var reference = _ref.reference,
      resolveReference = _ref.resolveReference,
      labels = _ref.labels;

  var _useState = useState(null),
      information = _useState[0],
      setInformation = _useState[1];

  var _useState2 = useState(true),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(0),
      retry = _useState3[0],
      setRetry = _useState3[1];

  var entityType = reference.entityType,
      entityId = reference.entityId;
  useEffect(function () {
    var active = true;
    setLoading(true);
    setInformation(null);

    var load = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(!resolveReference || entityType !== 'ASSIGNMENT')) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _context.next = 5;
                return resolveReference({
                  entityType: entityType,
                  entityId: entityId
                });

              case 5:
                result = _context.sent;
                if (active) setInformation(result);
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                if (active) setInformation(null);

              case 12:
                _context.prev = 12;
                if (active) setLoading(false);
                return _context.finish(12);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9, 12, 15]]);
      }));

      return function load() {
        return _ref2.apply(this, arguments);
      };
    }();

    load();
    return function () {
      active = false;
    };
  }, [entityType, entityId, resolveReference, retry]);
  return /*#__PURE__*/_jsx("div", {
    style: {
      marginTop: 12
    },
    children: loading ? /*#__PURE__*/_jsx(ReferenceCard, {
      children: /*#__PURE__*/_jsx(Skeleton, {
        active: true,
        paragraph: {
          rows: 1
        },
        title: {
          width: '60%'
        }
      })
    }) : information ? /*#__PURE__*/_jsx(ClassAssignmentItem, {
      variant: "reference",
      title: information.title,
      status: "\u2014",
      typeTag: information.typeTag,
      statusNode: information.statusNode,
      startTime: information.startTime,
      endTime: information.endTime,
      locale: information.locale,
      labels: labels,
      showDuration: false,
      href: information.href
    }) : /*#__PURE__*/_jsxs(ReferenceCard, {
      children: [/*#__PURE__*/_jsx("span", {
        className: "reference-information",
        children: labels.referenceUnavailable
      }), /*#__PURE__*/_jsx(Button, {
        size: "small",
        onClick: function onClick() {
          return setRetry(function (value) {
            return value + 1;
          });
        },
        children: labels.retry
      })]
    })
  });
};

export var ClassAnnouncementReferences = function ClassAnnouncementReferences(_ref3) {
  var _ref3$references = _ref3.references,
      references = _ref3$references === void 0 ? [] : _ref3$references,
      resolveReference = _ref3.resolveReference,
      labels = _ref3.labels;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: references.map(function (reference) {
      return /*#__PURE__*/_jsx(Reference, {
        reference: reference,
        resolveReference: resolveReference,
        labels: labels
      }, "".concat(reference.entityType, ":").concat(reference.entityId));
    })
  });
};